<script>
import broker from "./utils/broker";

export default {
  data() {
    return {
      theme: "",
      loading: true,
      meta: {},
      preview: false,
    };
  },
  computed: {},
  created() {
    // setTimeout(() => (this.loading = false), 4500);
  },
  mounted() {
    // this.changeIcon()
    broker.fetch.get(`/webschool/meta`).then((res) => {
      console.log(`-----meta`, res.data);

      this.meta = res.data.school;
      this.$store.dispatch("updateSchool", this.meta);
      const favicon = document.getElementById("favicon");
      favicon.href = this.meta.image;
      if (this.$route.query.preview) {
        this.preview = true;
        this.meta.preview = "?preview=" + this.$route.query.preview + "&";
      } else {
        this.meta.preview = "?";
      }
      this.loading = false;
    });
  },
  methods: {
    changeIcon() {
      const favicon = document.getElementById("favicon");
      favicon.href = "https://www.google.com/favicon.ico";
    },
  },
};
</script>
<template>
  <div id="app">
    <!-- Loader -->
    <div id="preloader" v-if="loading">
      <div id="status">
        <div class="spinner"></div>
      </div>
    </div>
    <div class="corner-ribbon right" v-if="preview">preview template</div>

    <router-view v-if="!loading" :dataMeta="meta" />
  </div>
</template>
